/** @format */

import { RatingSummaryIncludes } from './review-statistics.interface';

export interface RatingSummaryResponse {
  Errors: any[];
  HasErrors: boolean;
  Includes: RatingSummaryIncludes;
  Limit: number;
  Locale: string;
  Offset: number;
  Results: any[];
}
